<template>
  <div>
    <div class="ekko-lightbox modal fade in" style="display: block;">
      <div class="modal-dialog modal-lg">
        <div class="modal-container">
          <div class="modal-header">
            <button type="button" class="close" @click="$emit('close')">×</button>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in"></div>
  </div>
</template>

<script>
  export default {
    name: "PopupModel",
  };
</script>

<style scoped>
  .thin-vertical .ekko-lightbox {
    padding: 3px;
  }
    .thin-vertical .ekko-lightbox .modal-header {
      padding: 3px;
    }
  .ekko-lightbox{
    overflow: scroll;
  }
  .ekko-lightbox .modal-dialog .modal-container .container {
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// EcomCore/Components/Common/PopupModel.vue